module.exports = __webpack_public_path__ + "static/assets/36854ae363289b372d95a65546decb87.png";